import { CompositeLayer } from '@deck.gl/core'
import { PolygonLayer, TextLayer } from '@deck.gl/layers'
import { FeatureType } from 'stores/features'

class InsertedQuarterLayer extends CompositeLayer<any, any> {
  get type() {
    return FeatureType.Quarter
  }

  renderLayers() {
    return [
      new PolygonLayer(this.props.polygonProps, {
        id: 'drawedQuarterAreaAfterInsert',
        opacity: 0.1,
        pickable: true,
        filled: true,
        wireframe: true,
        lineWidthMinPixels: 1,
        getLineWidth: 1,
        getPolygon: (d: any) => d.contour
      }),
      new TextLayer(this.props.textProps, {
        id: 'drawedQuarterAreaAfterInsert-text',
        characterSet: 'auto',
        billboard: false,
        getPosition: (d: any) => {
          const coords = d.coordinates
          const latLng = [0, 0]

          for (const coord of coords) {
            latLng[0] += coord[0]
            latLng[1] += coord[1]
          }

          return [latLng[0] / coords.length, latLng[1] / coords.length]
        },
        getText: (d: any) => {
          return d.properties.title
        },
        parameters: {
          depthTest: false
        },
        getSize: 16,
        getAngle: 0,
        pickable: true,
        getTextAnchor: 'middle',
        getAlignmentBaseline: 'center',
        getColor: [255, 255, 255],
        background: true,
        fontFamily: 'Lato',
        backgroundPadding: [5, 5],
        updateTriggers: { visible: this.props.visible }
      })
    ]
  }
}

InsertedQuarterLayer.layerName = 'InsertedQuarterLayer'
export default InsertedQuarterLayer
